function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.00175609756 0.0234731707 24.0017561 0.0234731707 24.0017561 24.0234732 0.00175609756 24.0234732"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5546\\u54C1\\u7BA1\\u7406",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5BFC\\u822A",
  transform: "translate(-700.000000, -243.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-2",
  transform: "translate(652.000000, 229.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "jiagouyouhualei",
  transform: "translate(48.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  mask: "url(#mask-2)",
  fill: "#696D82"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.365133,7.52493673 C10.2705648,7.47315158 9.4232608,6.55115994 9.46817569,5.46081837 C9.52083453,4.37078527 10.445849,3.52668344 11.5408819,3.56913724 C12.6315394,3.61297917 13.4805083,4.54730979 13.4378779,5.63464373 C13.3844834,6.72425268 12.4597399,7.56758332 11.365133,7.52493673 M16.7354054,0.483351436 L16.6890966,0.310875647 L16.5145481,0.265838375 C13.547687,-0.516491441 8.96419961,0.265838375 5.05912067,4.80727665 C3.22794821,4.76463005 1.74451769,5.41713067 0.259848146,6.89445347 L0,7.15561567 L3.60000615,9.56723052 C3.12057838,10.4358561 3.40369709,11.7176832 4.31980603,12.6311918 C5.23730889,13.5436592 6.52307515,13.8266846 7.37339927,13.3698339 L9.79624801,17 L10.0572965,16.7387992 C11.5847513,15.2190226 12.2410121,13.7405431 12.1752273,11.893745 C16.7134514,7.98059208 17.521145,3.44038771 16.7354054,0.483351436",
  id: "Fill-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.33975808,13.6169287 C0.510049601,14.4467314 0,17 0,17 C0,17 2.45828983,16.5850712 3.38313881,15.6601361 C4.08506055,14.9584933 4.2130119,13.9368896 3.63734059,13.3612672 C3.06337019,12.7873454 2.04167983,12.9152859 1.33975808,13.6169287",
  id: "\\u8DEF\\u5F84",
  opacity: 0.600000024
})))))));

var SvgItemOptimize = function SvgItemOptimize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgItemOptimize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/itemOptimize.4d2871cd.svg";
export { ForwardRef as ReactComponent };